namespace TabAurous.OMS {
    export interface PromotionDetailsForm {
        CompanyId: Serenity.LookupEditor;
        ProductTypeId: Serenity.LookupEditor;
    }

    export class PromotionDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.PromotionDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PromotionDetailsForm.init)  {
                PromotionDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;

                Q.initFormType(PromotionDetailsForm, [
                    'CompanyId', w0,
                    'ProductTypeId', w0
                ]);
            }
        }
    }
}
